// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { defineCustomElements } from '@siemens/ix-brand-theme/loader';

defineCustomElements();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

